import React from 'react';
import Hero from '../components/home/Hero';
import StatsStrip from '../components/home/StatsStrip';
import AboutUs from '../components/home/AboutUs';
import ServicesSection from '../components/home/ServicesSection';
import ReconcileSection from '../components/home/ReconcileSection';
import CTASection from '../components/home/CTASection';
import './Home.css';

const Home = () => {
  return (
    <div className="dbh-home">
      <Hero />
      <StatsStrip />
      <AboutUs />
      <ServicesSection /> {/* OUR SOLUTIONS */}
      <ReconcileSection /> {/* OUR APPROACH */}
      <CTASection />
    </div>
  );
};

export default Home;